import { trackEvent } from "@hopper-b2b/api";
import { CONTINUE_TO_PAYMENT } from "@hopper-b2b/types";
import type { FlightMachineContext } from "../../types";

export const trackUberPayment = (
  context: FlightMachineContext,
  _event: unknown
) =>
  new Promise((resolve, _reject) => {
    try {
      window.parent.postMessage(
        {
          type: CONTINUE_TO_PAYMENT,
        },
        import.meta.env["VITE_UBER_URL"]
      );
    } catch (e) {
      //console.error(e)
    }

    trackEvent({
      eventName: CONTINUE_TO_PAYMENT,
      properties: undefined,
    })
      .then(() => resolve(null))
      .catch(() => resolve(null));
  });
